<template>
  <span>
    <v-toolbar dense
               fixed>
      <v-btn router
             flat
             to="/viewfreight"
             class="teal--text darken-2">Kangaruu</v-btn>
      <v-spacer></v-spacer>

      <v-btn class="teal--text darken-2"
             small
             router
             flat
             icon
             v-on:click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout>
      <v-flex xs12
              sm6
              offset-sm3>
        <v-toolbar class="teal">
          <v-toolbar-title class="white--text">
            <broker-name :brokerID="brokerID"></broker-name>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn small
                 flat
                 icon
                 v-on:click.native="$router.push({ name: 'shipperfreight', params: { shipmentID: freightID } })"
                 color="white">
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>

        </v-toolbar>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="teal--text daarken-4">Shipping Quote: {{quotes.quote}}</v-list-tile-title>
              <v-list-tile-sub-title class="blue--text caption"
                                     v-if="shipment.Miles">
                {{calculateRate(quotes.quote, shipment.Miles)}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon class="blue--text darken-4"
                      v-if="quotes.selected">check_circle</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <chat :messages="messages"
              :onSend="onSend"></chat>
      </v-flex>
    </v-layout>
  </span>
</template>

<script>

import db from './fireBaseInit'
import brokerName from './BrokerName'
import chat from './Chat'
import Firebase from 'firebase'
import moment from 'moment'

export default {
  name: 'brokerdetail',
  props: ['brokerID', 'freightID'],
  components: { chat, brokerName },
  data () {
    return {
      title: null,
      messages: {},
      quotes: {},
      shipment: {}
    }
  },
  calculated: {
  },
  mounted: function () {
    this.$bind('quotes', db.collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID))
      .then((doc) => {
        this.clearMessageFlag()
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  methods: {
    calculateRate: function (quote, miles) {
      var nQuote = 0
      var nMiles = 0
      if (quote != null) {
        nQuote = parseFloat(quote.replace(/[$,]+/g, ''))
      }
      if (miles != null) {
        nMiles = parseFloat(miles.replace(/[$,]+/g, ''))
      }
      console.log(quote, nQuote, nMiles)
      var currentRate = 2.75
      var avgRate = currentRate * nMiles
      var rateDiff = avgRate - nQuote
      // console.log(rateDiff)
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      var rateDiffString = formatter.format(rateDiff)
      console.log(avgRate, rateDiff, nQuote)
      if (avgRate >= nQuote && nQuote > 0 && nMiles > 0) {
        return `${rateDiffString} below market rate.`
      } else if (avgRate < nQuote && nQuote > 0 && nMiles > 0) {
        return `${rateDiffString} above market rate.`
      }
    },
    logout: function () {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    },
    clearMessageFlag: function () {
      var messages = {}
      messages['newMessage'] = false
      db.collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID).update(messages)
    },
    onSend (message) {
      var msg = {}
      msg['message'] = message
      msg['sender'] = Firebase.auth().currentUser.uid
      msg['created'] = moment().unix()
      db.collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID).collection('messages').add(msg)

      // update freight to new message
      var userList = this.shipment.newMessages
      var messages = {}
      userList[this.brokerID] = true
      messages['newMessages'] = userList
      db.collection('freight').doc(this.freightID).update(messages)

      // send push
      db.collection('users').doc(this.brokerID).get().then((snap) => {
        if (snap.data().sendPush) {
          db.collection('push').add({ sendTo: `${this.brokerID}` })
        }
      })
    }
  },
  firestore () {
    return {
      messages: db.collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID).collection('messages').orderBy('created'),
      shipment: db.collection('freight').doc(this.freightID)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BrokerDetail.vue